import * as React from 'react';
import Header from './Header';
import DaysBlock from './DaysBlock';
import NDate from '@nepo/ndate';
import { PersianMonthDays } from '../../../../enums/DateConsts';
import MonthBlock from './MonthBlock';
import YearBlock from './YearBlock';

import '../DatePicker.scss';
const createMonth = (year, month) => {
  const cal = new NDate([year, month, 1]);
  let currentSelectYear = year;
  let theDaysOfMonth = PersianMonthDays[month - 1];
  let dayOfWeek = cal.dayOfWeekJalali();
  if (theDaysOfMonth < 30) {
    if (NDate.isLeapYearJalali(year)) {
      theDaysOfMonth = 30;
    }
  }

  if (dayOfWeek < 0) {
    dayOfWeek = 6;
  }
  const totalDays = theDaysOfMonth + dayOfWeek;
  const daysArray = [];
  let day = 1;

  for (let i = 0; i < totalDays; i++) {
    if (i < dayOfWeek) {
      daysArray.push(null);
    } else if (i - dayOfWeek < theDaysOfMonth) {
      daysArray.push(new NDate([currentSelectYear, month, day]));
      day++;
    } else {
      daysArray.push(null);
    }
  }
  return daysArray;
};

const PersianDatePicker = props => {
  const [viewMode, setViewMode] = React.useState('days');
  const [daysObj, setDaysObj] = React.useState([]);
  const [referenceDate, setReferenceDate] = React.useState(new NDate());

  React.useEffect(() => {
    const MainDate = props.mainDate ? props.mainDate : new NDate();
    setReferenceDate(MainDate);
    setDaysObj(createMonth(MainDate.yearJalali, MainDate.monthJalali));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const nextMonthHandler = () => {
    const newDate = referenceDate;
    let theYear = newDate.yearJalali;
    let theMonth = newDate.monthJalali;
    theMonth++;
    if (theMonth === 13) {
      theMonth = 1;
      theYear++;
    }
    setReferenceDate(new NDate([theYear, theMonth, 1]));
    setDaysObj(createMonth(theYear, theMonth));
    setViewMode('days');
  };
  const prevMonthHandler = () => {
    const newDate = referenceDate;
    let theYear = newDate.yearJalali;
    let theMonth = newDate.monthJalali;
    theMonth--;
    if (theMonth === 0) {
      theMonth = 12;
      theYear--;
    }
    setReferenceDate(new NDate([theYear, theMonth, 1]));
    setDaysObj(createMonth(theYear, theMonth));
    setViewMode('days');
  };
  const monthSelectedHandler = month => {
    const newDate = new NDate([referenceDate.yearJalali, month, 1]);
    setReferenceDate(newDate);
    setDaysObj(createMonth(referenceDate.yearJalali, month));
    setViewMode('days');
  };
  const yearSeletedHandler = year => {
    const newDate = new NDate([year, referenceDate.monthJalali, 1]);
    setReferenceDate(newDate);
    setDaysObj(createMonth(year, referenceDate.monthJalali));
    setViewMode('months');
  };

  const daySelectedHandler = date => {
    console.log('date;;', date);
    setReferenceDate(date);
    props.onDateChange(date);
    props.onDaySelect();
  };
  return (
    <div className="DatePickerBlock">
      <div className="deatePickerArrow"></div>
      <Header
        mainDate={referenceDate}
        onMonthClick={() => {
          setViewMode('months');
        }}
        onYearClick={() => {
          setViewMode('years');
        }}
        nextMonth={nextMonthHandler}
        previusMonth={prevMonthHandler}
      />
      {viewMode === 'days' && <DaysBlock days={daysObj} onDaySelected={value => daySelectedHandler(value)} />}
      {viewMode === 'months' && <MonthBlock onMonthSelected={value => monthSelectedHandler(value)} />}
      {viewMode === 'years' && <YearBlock onYearClick={value => yearSeletedHandler(value)} />}
    </div>
  );
};

export default PersianDatePicker;
